export default "__VITE_ASSET__BBTQSL6w__";